/* import __COLOCATED_TEMPLATE__ from './page-upsell-card.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { get as persistableGet, remove as persistableRemove, set as persistableSet } from '@square/dashboard-utilities/utils/persistable';
import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { inject as service } from '@ember/service';
import { clickPageUpsellCardPrimary as es2PrimaryClickEvent, dismissPageUpsellCard as es2DismissEvent } from '@dashboard/shared-ui/events/page-upsell-card/eventstream/event-catalog';
import { clickPageUpsellCardPrimary as cdpPrimaryClickEvent, dismissPageUpsellCard as cdpDismissEvent } from '@dashboard/shared-ui/events/page-upsell-card/data-api/event-catalog';
const PAGE_UPSELL_CARD_PERSIST_KEY_PREFIX = 'shared-ui.upsell.page-upsell-card.dismissed';

/**
 * Usage Example:
 * <Upsell::PageUpsellCard
 *   @vertical={{this.Vertical.RESTAURANTS}}
 *   @onPrimaryButtonClick={{action (mut this.showUpsellSheet) true}}
 *   @primaryButtonClass="button-class"
 * >
 *   <:icon><SqIcon80DiagramGraphBar /></:icon>
 *   <:title>Section sales reports</:title>
 *   <:description>
 *     Need to easily see how each part of the restaurant—bar, dining room, or patio—is doing in sales?
 *   </:description>
 *   <:primary-button-text>Unlock with Plus</:primary-button-text>
 * </Upsell::PageUpsellCard>
 *
 * @yields icon - icon to display in the header
 * @yields title - h3 title copy
 * @yields description - description/paragraph copy
 * @yields primary-button-text - primary CTA copy
 *
 * @param {Action} onPrimaryButtonClick - action to take when primary button is clicked
 * @param {String} primaryButtonClass - CSS class to apply to the primary button
 * @param {String} vertical - vertical using this upsell card
 * @param {String} promoType - UpsellPromoType for this card
 * @param {String} [cardClass] - CSS class to apply to the card
 */
let PageUpsellCardComponent = (_class = class PageUpsellCardComponent extends Component {
  get persistenceKey() {
    return `${PAGE_UPSELL_CARD_PERSIST_KEY_PREFIX}.${this.args.promoType}`;
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "dataApi", _descriptor, this);
    _initializerDefineProperty(this, "eventstream", _descriptor2, this);
    _initializerDefineProperty(this, "isDismissed", _descriptor3, this);
    this.isDismissed = persistableGet(this.persistenceKey);
  }
  openCard() {
    this.isDismissed = false;
    if (persistableGet(this.persistenceKey)) {
      persistableRemove(this.persistenceKey);
    }
  }
  primaryButtonClick() {
    const {
      name,
      properties
    } = cdpPrimaryClickEvent(this.args.vertical, this.args.promoType);
    this.dataApi.track(name, properties);
    this.eventstream.track(es2PrimaryClickEvent(this.args.vertical, this.args.promoType));
    this.args.onPrimaryButtonClick();
  }
  dismissCard() {
    const {
      name,
      properties
    } = cdpDismissEvent(this.args.vertical, this.args.promoType);
    this.dataApi.track(name, properties);
    this.eventstream.track(es2DismissEvent(this.args.vertical, this.args.promoType));
    this.isDismissed = true;
    persistableSet(this.persistenceKey, true, OneTrustConsent.FUNCTIONAL);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "eventstream", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isDismissed", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "openCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "primaryButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "primaryButtonClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dismissCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dismissCard"), _class.prototype), _class);
export { PageUpsellCardComponent as default };